import { vsEntity2ApiBase as api } from './vsEntity2ApiBase';

const injectedRtkApi = api.injectEndpoints({
  endpoints: build => ({
    domainControllerFindAllDomain: build.query<
      DomainControllerFindAllDomainApiResponse,
      DomainControllerFindAllDomainApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/domain`,
        params: {
          cur_page: queryArg.curPage,
          page_size: queryArg.pageSize,
          sort_order: queryArg.sortOrder,
          sort_field: queryArg.sortField,
          search: queryArg.search,
          is_verified: queryArg.isVerified,
        },
      }),
    }),
    domainControllerCreateDomain: build.mutation<
      DomainControllerCreateDomainApiResponse,
      DomainControllerCreateDomainApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/domain`,
        method: 'POST',
        body: queryArg.createDomainRequestDto,
      }),
    }),
    domainControllerGetDomainUserList: build.query<
      DomainControllerGetDomainUserListApiResponse,
      DomainControllerGetDomainUserListApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/domain/user`,
      }),
    }),
    entityControllerGetEntity: build.query<
      EntityControllerGetEntityApiResponse,
      EntityControllerGetEntityApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}`,
      }),
    }),
    entityControllerUpdateEntity: build.mutation<
      EntityControllerUpdateEntityApiResponse,
      EntityControllerUpdateEntityApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}`,
        method: 'PATCH',
        body: queryArg.updateEntityRequestDto,
      }),
    }),
    entityControllerGetUserEntityList: build.query<
      EntityControllerGetUserEntityListApiResponse,
      EntityControllerGetUserEntityListApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/list`,
        params: {
          cur_page: queryArg.curPage,
          page_size: queryArg.pageSize,
          sort_order: queryArg.sortOrder,
          sort_field: queryArg.sortField,
          is_default_priority: queryArg.isDefaultPriority,
          name: queryArg.name,
        },
      }),
    }),
    entityGroupControllerFindAllGroups: build.query<
      EntityGroupControllerFindAllGroupsApiResponse,
      EntityGroupControllerFindAllGroupsApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/group`,
        params: { cur_page: queryArg.curPage, page_size: queryArg.pageSize },
      }),
    }),
    entityGroupControllerFindUserByGroup: build.query<
      EntityGroupControllerFindUserByGroupApiResponse,
      EntityGroupControllerFindUserByGroupApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/group/${queryArg.groupId}/users`,
        params: { page: queryArg.page, per_page: queryArg.perPage },
      }),
    }),
    entityGroupControllerGetGroupPolicies: build.query<
      EntityGroupControllerGetGroupPoliciesApiResponse,
      EntityGroupControllerGetGroupPoliciesApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/group/${queryArg.groupId}/policies`,
      }),
    }),
    policyControllerFindAll: build.query<
      PolicyControllerFindAllApiResponse,
      PolicyControllerFindAllApiArg
    >({
      query: () => ({ url: `/entity/api/v2/entity/policy/list` }),
    }),
    policyControllerFindAllWithUser: build.query<
      PolicyControllerFindAllWithUserApiResponse,
      PolicyControllerFindAllWithUserApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/policy`,
      }),
    }),
    signupRequestControllerGetAllEntityDomainTypes: build.query<
      SignupRequestControllerGetAllEntityDomainTypesApiResponse,
      SignupRequestControllerGetAllEntityDomainTypesApiArg
    >({
      query: () => ({
        url: `/entity/api/v2/entity/signup-request/entity_domain_type`,
      }),
    }),
    signupRequestControllerGetAllEntityGenerics: build.query<
      SignupRequestControllerGetAllEntityGenericsApiResponse,
      SignupRequestControllerGetAllEntityGenericsApiArg
    >({
      query: () => ({
        url: `/entity/api/v2/entity/signup-request/entity_generics`,
      }),
    }),
    signupRequestControllerGetEntityRequestList: build.query<
      SignupRequestControllerGetEntityRequestListApiResponse,
      SignupRequestControllerGetEntityRequestListApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/signup-request`,
        params: {
          cur_page: queryArg.curPage,
          page_size: queryArg.pageSize,
          sort_order: queryArg.sortOrder,
          sort_field: queryArg.sortField,
          search: queryArg.search,
          status: queryArg.status,
        },
      }),
    }),
    signupRequestControllerCreateSignUpRequest: build.mutation<
      SignupRequestControllerCreateSignUpRequestApiResponse,
      SignupRequestControllerCreateSignUpRequestApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/signup-request`,
        method: 'POST',
        body: queryArg.createEntityRequestFormRequestDto,
      }),
    }),
    signupRequestControllerGetEntityRequest: build.query<
      SignupRequestControllerGetEntityRequestApiResponse,
      SignupRequestControllerGetEntityRequestApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/signup-request/${queryArg.id}`,
      }),
    }),
    signupRequestControllerGetInviteEntityRequestList: build.query<
      SignupRequestControllerGetInviteEntityRequestListApiResponse,
      SignupRequestControllerGetInviteEntityRequestListApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/signup-request/invitation`,
        params: {
          cur_page: queryArg.curPage,
          page_size: queryArg.pageSize,
          sort_order: queryArg.sortOrder,
          sort_field: queryArg.sortField,
          search: queryArg.search,
          status: queryArg.status,
        },
      }),
    }),
    signupRequestControllerCreateInvitationEntityRequest: build.mutation<
      SignupRequestControllerCreateInvitationEntityRequestApiResponse,
      SignupRequestControllerCreateInvitationEntityRequestApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/signup-request/invitation`,
        method: 'POST',
        body: queryArg.inviteEntityRequestRequestDto,
      }),
    }),
    signupRequestControllerGetInviteEntityRequestById: build.query<
      SignupRequestControllerGetInviteEntityRequestByIdApiResponse,
      SignupRequestControllerGetInviteEntityRequestByIdApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/signup-request/invitation/${queryArg.invitationId}`,
      }),
    }),
    signupRequestControllerCreateSignUpRequestByInvitation: build.mutation<
      SignupRequestControllerCreateSignUpRequestByInvitationApiResponse,
      SignupRequestControllerCreateSignUpRequestByInvitationApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/signup-request/invitation/${queryArg.invitationId}`,
        method: 'POST',
        body: queryArg.createEntityRequestFormRequestDto,
      }),
    }),
    entityUserControllerPolicyInfo: build.query<
      EntityUserControllerPolicyInfoApiResponse,
      EntityUserControllerPolicyInfoApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/user/policy-info`,
      }),
    }),
    entityUserControllerFindAll: build.mutation<
      EntityUserControllerFindAllApiResponse,
      EntityUserControllerFindAllApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/users/list`,
        method: 'POST',
        body: queryArg.getEntityUserListDto,
      }),
    }),
    entityUserControllerGetUserPolicies: build.query<
      EntityUserControllerGetUserPoliciesApiResponse,
      EntityUserControllerGetUserPoliciesApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/user/${queryArg.userId}/policy`,
      }),
    }),
    entityUserControllerGetUserByPolicyCode: build.query<
      EntityUserControllerGetUserByPolicyCodeApiResponse,
      EntityUserControllerGetUserByPolicyCodeApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/users/policy/${queryArg.policyCode}`,
        params: {
          cur_page: queryArg.curPage,
          page_size: queryArg.pageSize,
          sort_order: queryArg.sortOrder,
          account: queryArg.account,
          action: queryArg.action,
        },
      }),
    }),
    syncJobQueryControllerListSyncJobs: build.query<
      SyncJobQueryControllerListSyncJobsApiResponse,
      SyncJobQueryControllerListSyncJobsApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/sync-jobs`,
        params: { cur_page: queryArg.curPage, page_size: queryArg.pageSize },
      }),
    }),
    syncJobQueryControllerGetSyncJob: build.query<
      SyncJobQueryControllerGetSyncJobApiResponse,
      SyncJobQueryControllerGetSyncJobApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/sync-jobs/${queryArg.jobId}`,
      }),
    }),
    userSyncControllerGetEntitySyncList: build.query<
      UserSyncControllerGetEntitySyncListApiResponse,
      UserSyncControllerGetEntitySyncListApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/sync`,
        params: { return_uri: queryArg.returnUri },
      }),
    }),
    userSyncControllerGetSyncHistory: build.query<
      UserSyncControllerGetSyncHistoryApiResponse,
      UserSyncControllerGetSyncHistoryApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/sync/history`,
        params: { state: queryArg.state },
      }),
    }),
    userSyncCommandControllerCreateSyncHistory: build.mutation<
      UserSyncCommandControllerCreateSyncHistoryApiResponse,
      UserSyncCommandControllerCreateSyncHistoryApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/sync/history`,
        method: 'POST',
        body: queryArg.createSyncHistoryRequestDto,
      }),
    }),
    csvControllerCsvChecker: build.mutation<
      CsvControllerCsvCheckerApiResponse,
      CsvControllerCsvCheckerApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/csv/checker`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    azureControllerGetTenantList: build.query<
      AzureControllerGetTenantListApiResponse,
      AzureControllerGetTenantListApiArg
    >({
      query: () => ({ url: `/entity/api/v2/entity/user-sync/azure/tenants` }),
    }),
    azureControllerGetTenantGroups: build.query<
      AzureControllerGetTenantGroupsApiResponse,
      AzureControllerGetTenantGroupsApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/user-sync/azure/tenants/${queryArg.tenantId}/groups`,
        params: {
          page_token: queryArg.pageToken,
          page_size: queryArg.pageSize,
          search: queryArg.search,
        },
      }),
    }),
    azureControllerGetTenantSubGroups: build.query<
      AzureControllerGetTenantSubGroupsApiResponse,
      AzureControllerGetTenantSubGroupsApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/user-sync/azure/tenants/${queryArg.tenantId}/groups/${queryArg.groupId}`,
        params: {
          page_token: queryArg.pageToken,
          page_size: queryArg.pageSize,
          search: queryArg.search,
        },
      }),
    }),
    gSuiteControllerGetEntityList: build.query<
      GSuiteControllerGetEntityListApiResponse,
      GSuiteControllerGetEntityListApiArg
    >({
      query: () => ({ url: `/entity/api/v2/entity/user-sync/gsuite/domains` }),
    }),
    gSuiteControllerGetDomainGroups: build.query<
      GSuiteControllerGetDomainGroupsApiResponse,
      GSuiteControllerGetDomainGroupsApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/user-sync/gsuite/domains/${queryArg.domainName}/groups`,
        params: {
          page_token: queryArg.pageToken,
          page_size: queryArg.pageSize,
          search: queryArg.search,
        },
      }),
    }),
    gSuiteControllerGetDomainSubGroups: build.query<
      GSuiteControllerGetDomainSubGroupsApiResponse,
      GSuiteControllerGetDomainSubGroupsApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/user-sync/gsuite/domains/${queryArg.domainName}/groups/${queryArg.groupId}`,
        params: {
          page_token: queryArg.pageToken,
          page_size: queryArg.pageSize,
        },
      }),
    }),
    gSuiteControllerGetDomainUnits: build.query<
      GSuiteControllerGetDomainUnitsApiResponse,
      GSuiteControllerGetDomainUnitsApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/user-sync/gsuite/units`,
        params: { unit_path: queryArg.unitPath },
      }),
    }),
    classLinkControllerGetTenantList: build.query<
      ClassLinkControllerGetTenantListApiResponse,
      ClassLinkControllerGetTenantListApiArg
    >({
      query: () => ({
        url: `/entity/api/v2/entity/user-sync/classlink/tenants`,
      }),
    }),
    classLinkControllerGetTenant: build.query<
      ClassLinkControllerGetTenantApiResponse,
      ClassLinkControllerGetTenantApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/user-sync/classlink/tenants/${queryArg.tenantId}`,
      }),
    }),
    classLinkControllerGetOrgList: build.query<
      ClassLinkControllerGetOrgListApiResponse,
      ClassLinkControllerGetOrgListApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/user-sync/classlink/tenants/${queryArg.tenantId}/orgs`,
        params: { type: queryArg['type'] },
      }),
    }),
    classLinkControllerGetOrgTypeList: build.query<
      ClassLinkControllerGetOrgTypeListApiResponse,
      ClassLinkControllerGetOrgTypeListApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/user-sync/classlink/tenants/${queryArg.tenantId}/orgs/types`,
      }),
    }),
    classLinkControllerGetRoleList: build.query<
      ClassLinkControllerGetRoleListApiResponse,
      ClassLinkControllerGetRoleListApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/user-sync/classlink/tenants/${queryArg.tenantId}/roles`,
      }),
    }),
    entityAutoApproverManagementControllerGetEntityAutoApproverList:
      build.query<
        EntityAutoApproverManagementControllerGetEntityAutoApproverListApiResponse,
        EntityAutoApproverManagementControllerGetEntityAutoApproverListApiArg
      >({
        query: queryArg => ({
          url: `/entity/api/v2/management/auto_approver`,
          params: {
            cur_page: queryArg.curPage,
            page_size: queryArg.pageSize,
            sort_order: queryArg.sortOrder,
            search: queryArg.search,
            sort_field: queryArg.sortField,
          },
        }),
      }),
    autoApproverManagementControllerAddApprover: build.mutation<
      AutoApproverManagementControllerAddApproverApiResponse,
      AutoApproverManagementControllerAddApproverApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/auto_approver`,
        method: 'POST',
        body: queryArg.createAutoApproverRequestDto,
      }),
    }),
    countryManagerManagementControllerGetCountryManagerList: build.query<
      CountryManagerManagementControllerGetCountryManagerListApiResponse,
      CountryManagerManagementControllerGetCountryManagerListApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/country_managers`,
        params: {
          cur_page: queryArg.curPage,
          page_size: queryArg.pageSize,
          sort_order: queryArg.sortOrder,
          sort_field: queryArg.sortField,
          search: queryArg.search,
        },
      }),
    }),
    countryManagerManagementControllerCreateCountryManager: build.mutation<
      CountryManagerManagementControllerCreateCountryManagerApiResponse,
      CountryManagerManagementControllerCreateCountryManagerApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/country_managers`,
        method: 'POST',
        body: queryArg.createCountryManagerRequestDto,
      }),
    }),
    domainManagementControllerGetDomain: build.query<
      DomainManagementControllerGetDomainApiResponse,
      DomainManagementControllerGetDomainApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/domain/${queryArg.entityId}`,
      }),
    }),
    domainManagementControllerGetDomainWhitelist: build.query<
      DomainManagementControllerGetDomainWhitelistApiResponse,
      DomainManagementControllerGetDomainWhitelistApiArg
    >({
      query: () => ({ url: `/entity/api/v2/management/domain/whitelist` }),
    }),
    entityManagementControllerGetEntityDetail: build.query<
      EntityManagementControllerGetEntityDetailApiResponse,
      EntityManagementControllerGetEntityDetailApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/entity/${queryArg.entityId}`,
      }),
    }),
    managementEntityControllerUpdateEntity: build.mutation<
      ManagementEntityControllerUpdateEntityApiResponse,
      ManagementEntityControllerUpdateEntityApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/entity/${queryArg.entityId}`,
        method: 'PUT',
        body: queryArg.adminUpdateEntityRequestDto,
      }),
    }),
    managementEntityControllerDeleteEntity: build.mutation<
      ManagementEntityControllerDeleteEntityApiResponse,
      ManagementEntityControllerDeleteEntityApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/entity/${queryArg.entityId}`,
        method: 'DELETE',
      }),
    }),
    entityManagementControllerGetEntityList: build.query<
      EntityManagementControllerGetEntityListApiResponse,
      EntityManagementControllerGetEntityListApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/entity/list`,
        params: {
          cur_page: queryArg.curPage,
          page_size: queryArg.pageSize,
          sort_order: queryArg.sortOrder,
          sort_field: queryArg.sortField,
          search: queryArg.search,
        },
      }),
    }),
    policyManagementControllerGetPolicies: build.query<
      PolicyManagementControllerGetPoliciesApiResponse,
      PolicyManagementControllerGetPoliciesApiArg
    >({
      query: () => ({ url: `/entity/api/v2/management/policy` }),
    }),
    policyManagementControllerGetPermissions: build.query<
      PolicyManagementControllerGetPermissionsApiResponse,
      PolicyManagementControllerGetPermissionsApiArg
    >({
      query: () => ({ url: `/entity/api/v2/management/policy/permission` }),
    }),
    policyManagementControllerGetActions: build.query<
      PolicyManagementControllerGetActionsApiResponse,
      PolicyManagementControllerGetActionsApiArg
    >({
      query: () => ({ url: `/entity/api/v2/management/policy/action` }),
    }),
    policyManagementControllerGetResources: build.query<
      PolicyManagementControllerGetResourcesApiResponse,
      PolicyManagementControllerGetResourcesApiArg
    >({
      query: () => ({ url: `/entity/api/v2/management/policy/resource` }),
    }),
    profileManagementControllerGetEntityDetail: build.query<
      ProfileManagementControllerGetEntityDetailApiResponse,
      ProfileManagementControllerGetEntityDetailApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/profile/${queryArg.entityId}`,
      }),
    }),
    regionManagerManagementControllerGetRegionManagerList: build.query<
      RegionManagerManagementControllerGetRegionManagerListApiResponse,
      RegionManagerManagementControllerGetRegionManagerListApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/region_managers`,
        params: {
          cur_page: queryArg.curPage,
          page_size: queryArg.pageSize,
          sort_order: queryArg.sortOrder,
          sort_field: queryArg.sortField,
          search: queryArg.search,
        },
      }),
    }),
    regionManagerManagementControllerCreateRegionManager: build.mutation<
      RegionManagerManagementControllerCreateRegionManagerApiResponse,
      RegionManagerManagementControllerCreateRegionManagerApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/region_managers`,
        method: 'POST',
        body: queryArg.createRegionManagerRequestDto,
      }),
    }),
    signupManagementControllerGetEntityRequestForAdmin: build.query<
      SignupManagementControllerGetEntityRequestForAdminApiResponse,
      SignupManagementControllerGetEntityRequestForAdminApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/entity_request/${queryArg.id}`,
      }),
    }),
    signupManagementControllerUpdateEntityRequest: build.mutation<
      SignupManagementControllerUpdateEntityRequestApiResponse,
      SignupManagementControllerUpdateEntityRequestApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/entity_request/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.updateEntityRequestBodyDto,
      }),
    }),
    signupManagementControllerGetInviteEntityRequestForAdmin: build.query<
      SignupManagementControllerGetInviteEntityRequestForAdminApiResponse,
      SignupManagementControllerGetInviteEntityRequestForAdminApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/entity_request/invite/${queryArg.id}`,
      }),
    }),
    signupManagementControllerGetEntityRequestListForAdmin: build.query<
      SignupManagementControllerGetEntityRequestListForAdminApiResponse,
      SignupManagementControllerGetEntityRequestListForAdminApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/entity_request`,
        params: {
          cur_page: queryArg.curPage,
          page_size: queryArg.pageSize,
          sort_order: queryArg.sortOrder,
          sort_field: queryArg.sortField,
          search: queryArg.search,
          status: queryArg.status,
          kind: queryArg.kind,
        },
      }),
    }),
    entityUserManagementControllerFindAll: build.mutation<
      EntityUserManagementControllerFindAllApiResponse,
      EntityUserManagementControllerFindAllApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/entity/${queryArg.entityId}/users/list`,
        method: 'POST',
        body: queryArg.getEntityUserListDto,
      }),
    }),
    userEntityManagementControllerGetUserEntities: build.query<
      UserEntityManagementControllerGetUserEntitiesApiResponse,
      UserEntityManagementControllerGetUserEntitiesApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/user/${queryArg.userId}/entities`,
        params: { cur_page: queryArg.curPage, page_size: queryArg.pageSize },
      }),
    }),
    domainControllerVerifyDomain: build.mutation<
      DomainControllerVerifyDomainApiResponse,
      DomainControllerVerifyDomainApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/domain/${queryArg.domainId}/verify/${queryArg.verifyType}`,
        method: 'POST',
      }),
    }),
    domainControllerDeleteDomain: build.mutation<
      DomainControllerDeleteDomainApiResponse,
      DomainControllerDeleteDomainApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/domain/${queryArg.domainId}`,
        method: 'DELETE',
      }),
    }),
    entityUserControllerCreate: build.mutation<
      EntityUserControllerCreateApiResponse,
      EntityUserControllerCreateApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/users`,
        method: 'POST',
        body: queryArg.addEntityUsersRequestDto,
      }),
    }),
    entityUserControllerRemoveUser: build.mutation<
      EntityUserControllerRemoveUserApiResponse,
      EntityUserControllerRemoveUserApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/users`,
        method: 'DELETE',
        body: queryArg.deleteMspUsersRequestDto,
      }),
    }),
    entityUserControllerSyncUsers: build.mutation<
      EntityUserControllerSyncUsersApiResponse,
      EntityUserControllerSyncUsersApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/users/sync`,
        method: 'POST',
        body: queryArg.syncEntityUsersRequestDto,
      }),
    }),
    nfcControllerBind: build.mutation<
      NfcControllerBindApiResponse,
      NfcControllerBindApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/users/${queryArg.userId}/nfc`,
        method: 'PUT',
        body: queryArg.bindEntityNfcDto,
      }),
    }),
    nfcControllerUnbind: build.mutation<
      NfcControllerUnbindApiResponse,
      NfcControllerUnbindApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/users/${queryArg.userId}/nfc`,
        method: 'DELETE',
      }),
    }),
    nfcControllerClear: build.mutation<
      NfcControllerClearApiResponse,
      NfcControllerClearApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/nfc`,
        method: 'DELETE',
        body: queryArg.clearEntityNfcDto,
      }),
    }),
    nfcControllerList: build.query<
      NfcControllerListApiResponse,
      NfcControllerListApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/nfc`,
        params: {
          q: queryArg.q,
          page: queryArg.page,
          page_size: queryArg.pageSize,
          sort: queryArg.sort,
          order: queryArg.order,
        },
      }),
    }),
    nfcControllerListCards: build.query<
      NfcControllerListCardsApiResponse,
      NfcControllerListCardsApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/nfc/cards`,
        params: {
          q: queryArg.q,
          page: queryArg.page,
          page_size: queryArg.pageSize,
          sort: queryArg.sort,
          order: queryArg.order,
        },
      }),
    }),
    nfcControllerExportCards: build.query<
      NfcControllerExportCardsApiResponse,
      NfcControllerExportCardsApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/nfc/cards/export`,
        params: { q: queryArg.q },
      }),
    }),
    nfcControllerListOrderCards: build.query<
      NfcControllerListOrderCardsApiResponse,
      NfcControllerListOrderCardsApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/nfc/orders/${queryArg.orderNo}/cards`,
      }),
    }),
    nfcControllerParseCsv: build.mutation<
      NfcControllerParseCsvApiResponse,
      NfcControllerParseCsvApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/nfc/csv/parse`,
        method: 'POST',
        body: queryArg.body,
      }),
    }),
    nfcControllerBatchBind: build.mutation<
      NfcControllerBatchBindApiResponse,
      NfcControllerBatchBindApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/nfc/batch`,
        method: 'POST',
        body: queryArg.importEntityNfcCsvDto,
      }),
    }),
    entityControllerAcceptUser: build.query<
      EntityControllerAcceptUserApiResponse,
      EntityControllerAcceptUserApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/accept/user`,
        params: { code: queryArg.code },
      }),
    }),
    entityControllerUpdateEntityOwner: build.mutation<
      EntityControllerUpdateEntityOwnerApiResponse,
      EntityControllerUpdateEntityOwnerApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/change_owner`,
        method: 'POST',
        body: queryArg.updateEntityOwnerRequestDto,
      }),
    }),
    entityControllerSetEntityDefault: build.mutation<
      EntityControllerSetEntityDefaultApiResponse,
      EntityControllerSetEntityDefaultApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/default`,
        method: 'POST',
        body: queryArg.setEntityDefaultRequestDto,
      }),
    }),
    policyControllerUpdateUserPolicy: build.mutation<
      PolicyControllerUpdateUserPolicyApiResponse,
      PolicyControllerUpdateUserPolicyApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/policy/user`,
        method: 'PUT',
        body: queryArg.updateUserPolicyRequestDto,
      }),
    }),
    syncJobControllerCreateGSuiteSyncJob: build.mutation<
      SyncJobControllerCreateGSuiteSyncJobApiResponse,
      SyncJobControllerCreateGSuiteSyncJobApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/sync-jobs/gsuite`,
        method: 'POST',
        body: queryArg.createGSuiteSyncJobDto,
      }),
    }),
    syncJobControllerCreateAzureSyncJob: build.mutation<
      SyncJobControllerCreateAzureSyncJobApiResponse,
      SyncJobControllerCreateAzureSyncJobApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/sync-jobs/azure`,
        method: 'POST',
        body: queryArg.createAzureSyncJobDto,
      }),
    }),
    syncJobControllerCreateClassLinkSyncJob: build.mutation<
      SyncJobControllerCreateClassLinkSyncJobApiResponse,
      SyncJobControllerCreateClassLinkSyncJobApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/sync-jobs/classlink`,
        method: 'POST',
        body: queryArg.createClassLinkSyncJobDto,
      }),
    }),
    syncJobControllerCreateCsvSyncJob: build.mutation<
      SyncJobControllerCreateCsvSyncJobApiResponse,
      SyncJobControllerCreateCsvSyncJobApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/sync-jobs/csv`,
        method: 'POST',
        body: queryArg.createCsvSyncJobDto,
      }),
    }),
    syncJobControllerPauseSyncJob: build.mutation<
      SyncJobControllerPauseSyncJobApiResponse,
      SyncJobControllerPauseSyncJobApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/sync-jobs/${queryArg.jobId}/pause`,
        method: 'POST',
      }),
    }),
    syncJobControllerResumeSyncJob: build.mutation<
      SyncJobControllerResumeSyncJobApiResponse,
      SyncJobControllerResumeSyncJobApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/sync-jobs/${queryArg.jobId}/resume`,
        method: 'POST',
      }),
    }),
    syncJobControllerCancelSyncJob: build.mutation<
      SyncJobControllerCancelSyncJobApiResponse,
      SyncJobControllerCancelSyncJobApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/sync-jobs/${queryArg.jobId}/cancel`,
        method: 'POST',
      }),
    }),
    userSyncCommandControllerUpdateSyncHistory: build.mutation<
      UserSyncCommandControllerUpdateSyncHistoryApiResponse,
      UserSyncCommandControllerUpdateSyncHistoryApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/entity/${queryArg.entityId}/sync/history/${queryArg.historyId}/state`,
        method: 'PATCH',
        body: queryArg.updateSyncHistoryStateRequestDto,
      }),
    }),
    signupRequestControllerApprove: build.mutation<
      SignupRequestControllerApproveApiResponse,
      SignupRequestControllerApproveApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/entity/signup-request/${queryArg.id}/approve`,
        method: 'POST',
      }),
    }),
    signupRequestControllerDeleteEntityRequest: build.mutation<
      SignupRequestControllerDeleteEntityRequestApiResponse,
      SignupRequestControllerDeleteEntityRequestApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/entity/signup-request/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    managementEntityControllerUpdateEntityOwner: build.mutation<
      ManagementEntityControllerUpdateEntityOwnerApiResponse,
      ManagementEntityControllerUpdateEntityOwnerApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/entity/${queryArg.entityId}/change_owner`,
        method: 'POST',
        body: queryArg.updateEntityOwnerRequestDto,
      }),
    }),
    managementEntityUserControllerAdd: build.mutation<
      ManagementEntityUserControllerAddApiResponse,
      ManagementEntityUserControllerAddApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/entity/${queryArg.entityId}/users`,
        method: 'POST',
        body: queryArg.forceAddEntityUsersRequestDto,
      }),
    }),
    managementEntityUserControllerRemoveUser: build.mutation<
      ManagementEntityUserControllerRemoveUserApiResponse,
      ManagementEntityUserControllerRemoveUserApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/entity/${queryArg.entityId}/users`,
        method: 'DELETE',
        body: queryArg.deleteMspUsersRequestDto,
      }),
    }),
    managementEntityUserControllerCreate: build.mutation<
      ManagementEntityUserControllerCreateApiResponse,
      ManagementEntityUserControllerCreateApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/entity/${queryArg.entityId}/users/import`,
        method: 'POST',
        body: queryArg.addEntityUsersRequestDto,
      }),
    }),
    domainManagementCommandControllerSetDomainVerified: build.mutation<
      DomainManagementCommandControllerSetDomainVerifiedApiResponse,
      DomainManagementCommandControllerSetDomainVerifiedApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/domain/${queryArg.domainId}/is_verified/${queryArg.isVerified}`,
        method: 'POST',
      }),
    }),
    domainManagementCommandControllerSetDomainVerifyType: build.mutation<
      DomainManagementCommandControllerSetDomainVerifyTypeApiResponse,
      DomainManagementCommandControllerSetDomainVerifyTypeApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/domain/${queryArg.domainId}/verify_type/${queryArg.verifyType}`,
        method: 'POST',
      }),
    }),
    domainManagementCommandControllerAddDomain: build.mutation<
      DomainManagementCommandControllerAddDomainApiResponse,
      DomainManagementCommandControllerAddDomainApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/domain/${queryArg.entityId}/${queryArg.domainName}/${queryArg.verifyType}`,
        method: 'POST',
      }),
    }),
    domainManagementCommandControllerDeleteDomain: build.mutation<
      DomainManagementCommandControllerDeleteDomainApiResponse,
      DomainManagementCommandControllerDeleteDomainApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/domain/${queryArg.domainId}`,
        method: 'DELETE',
      }),
    }),
    signupManagementControllerResend: build.mutation<
      SignupManagementControllerResendApiResponse,
      SignupManagementControllerResendApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/entity_request/${queryArg.id}/resend`,
        method: 'POST',
      }),
    }),
    signupManagementControllerReject: build.mutation<
      SignupManagementControllerRejectApiResponse,
      SignupManagementControllerRejectApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/entity_request/${queryArg.id}/reject`,
        method: 'POST',
        body: queryArg.entityRequestReasonBodyDto,
      }),
    }),
    signupManagementControllerPend: build.mutation<
      SignupManagementControllerPendApiResponse,
      SignupManagementControllerPendApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/entity_request/${queryArg.id}/pend`,
        method: 'POST',
        body: queryArg.entityRequestReasonBodyDto,
      }),
    }),
    autoApproverManagementControllerDeleteApprover: build.mutation<
      AutoApproverManagementControllerDeleteApproverApiResponse,
      AutoApproverManagementControllerDeleteApproverApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/auto_approver/${queryArg.userId}`,
        method: 'DELETE',
      }),
    }),
    regionManagerManagementControllerUpdateRegionManager: build.mutation<
      RegionManagerManagementControllerUpdateRegionManagerApiResponse,
      RegionManagerManagementControllerUpdateRegionManagerApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/region_managers/${queryArg.region}`,
        method: 'PUT',
        body: queryArg.updateRegionManagerRequestDto,
      }),
    }),
    regionManagerManagementControllerDeleteRegionManager: build.mutation<
      RegionManagerManagementControllerDeleteRegionManagerApiResponse,
      RegionManagerManagementControllerDeleteRegionManagerApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/region_managers/${queryArg.region}`,
        method: 'DELETE',
      }),
    }),
    countryManagerManagementControllerUpdateCountryManager: build.mutation<
      CountryManagerManagementControllerUpdateCountryManagerApiResponse,
      CountryManagerManagementControllerUpdateCountryManagerApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/country_managers/${queryArg.country}`,
        method: 'PUT',
        body: queryArg.updateCountryManagerRequestDto,
      }),
    }),
    countryManagerManagementControllerDeleteCountryManager: build.mutation<
      CountryManagerManagementControllerDeleteCountryManagerApiResponse,
      CountryManagerManagementControllerDeleteCountryManagerApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/country_managers/${queryArg.country}`,
        method: 'DELETE',
      }),
    }),
    profileManagementControllerUpdateEntityProfile: build.mutation<
      ProfileManagementControllerUpdateEntityProfileApiResponse,
      ProfileManagementControllerUpdateEntityProfileApiArg
    >({
      query: queryArg => ({
        url: `/entity/api/v2/management/profile`,
        method: 'PUT',
        body: queryArg.updateEntityProfileRequestDto,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as vsEntity2ApiInjected };
export type DomainControllerFindAllDomainApiResponse =
  /** status 200  */ PaginationEntityDomainResponseDto;
export type DomainControllerFindAllDomainApiArg = {
  /** current page */
  curPage?: number;
  /** page size */
  pageSize?: number;
  /** sort order */
  sortOrder?: 'ASC' | 'DESC';
  /** sort by create time */
  sortField?: string;
  /** search word */
  search?: string;
  /** true or false is_verified of domain */
  isVerified?: string;
  entityId: string;
};
export type DomainControllerCreateDomainApiResponse = unknown;
export type DomainControllerCreateDomainApiArg = {
  entityId: string;
  createDomainRequestDto: CreateDomainRequestDto;
};
export type DomainControllerGetDomainUserListApiResponse =
  /** status 200  */ DomainUserListWithStatusResponseDto[];
export type DomainControllerGetDomainUserListApiArg = {
  entityId: string;
};
export type EntityControllerGetEntityApiResponse =
  /** status 200  */ GetEntityResponseDto;
export type EntityControllerGetEntityApiArg = {
  entityId: string;
};
export type EntityControllerUpdateEntityApiResponse =
  /** status 200  */ CommonResponseDto;
export type EntityControllerUpdateEntityApiArg = {
  entityId: string;
  updateEntityRequestDto: UpdateEntityRequestDto;
};
export type EntityControllerGetUserEntityListApiResponse =
  /** status 200  */ GetUserEntityListWithPaginationResponseDto;
export type EntityControllerGetUserEntityListApiArg = {
  /** current page */
  curPage?: number;
  /** page size */
  pageSize?: number;
  /** sort order */
  sortOrder?: 'ASC' | 'DESC';
  /** sort by create time */
  sortField?: string;
  /** is default entity priority or not */
  isDefaultPriority?: boolean;
  /** entity name for searching */
  name?: string;
};
export type EntityGroupControllerFindAllGroupsApiResponse =
  /** status 200  */ EntityGroupListResponseDto;
export type EntityGroupControllerFindAllGroupsApiArg = {
  entityId: string;
  /** current page */
  curPage?: number;
  /** page size */
  pageSize?: number;
};
export type EntityGroupControllerFindUserByGroupApiResponse =
  /** status 200  */ EntityGroupUserListResponseDto;
export type EntityGroupControllerFindUserByGroupApiArg = {
  entityId: string;
  groupId: string;
  page: number;
  perPage: number;
};
export type EntityGroupControllerGetGroupPoliciesApiResponse =
  /** status 200  */ EntityGroupPolicyResponseDto;
export type EntityGroupControllerGetGroupPoliciesApiArg = {
  entityId: string;
  groupId: string;
};
export type PolicyControllerFindAllApiResponse =
  /** status 200  */ GetEntityPolicyResponseDto[];
export type PolicyControllerFindAllApiArg = void;
export type PolicyControllerFindAllWithUserApiResponse =
  /** status 200  */ GetEntityPolicyWithUserResponseDto[];
export type PolicyControllerFindAllWithUserApiArg = {
  entityId: string;
};
export type SignupRequestControllerGetAllEntityDomainTypesApiResponse =
  /** status 200 use code, present with name */ GetAllEntityDomainTypesResponseDto[];
export type SignupRequestControllerGetAllEntityDomainTypesApiArg = void;
export type SignupRequestControllerGetAllEntityGenericsApiResponse =
  /** status 200 use code, present with name */ GetAllEntityGenericsResponseDto[];
export type SignupRequestControllerGetAllEntityGenericsApiArg = void;
export type SignupRequestControllerGetEntityRequestListApiResponse =
  /** status 200  */ GetEntityRequestListResponseDto;
export type SignupRequestControllerGetEntityRequestListApiArg = {
  /** current page */
  curPage?: number;
  /** page size */
  pageSize?: number;
  /** sort order */
  sortOrder?: 'ASC' | 'DESC';
  /** sort by name */
  sortField?: string;
  /** search for searching */
  search?: string;
  /** entity request status */
  status?: 'new' | 'approve' | 'reject' | 'pending' | 'success' | 'failed';
};
export type SignupRequestControllerCreateSignUpRequestApiResponse =
  /** status 200  */ CreateEntityRequestResponseDto;
export type SignupRequestControllerCreateSignUpRequestApiArg = {
  createEntityRequestFormRequestDto: CreateEntityRequestFormRequestDto;
};
export type SignupRequestControllerGetEntityRequestApiResponse =
  /** status 200  */ GetEntityRequestResponseDto;
export type SignupRequestControllerGetEntityRequestApiArg = {
  id: string;
};
export type SignupRequestControllerGetInviteEntityRequestListApiResponse =
  /** status 200  */ GetInviteEntityRequestListResponseDto;
export type SignupRequestControllerGetInviteEntityRequestListApiArg = {
  /** current page */
  curPage?: number;
  /** page size */
  pageSize?: number;
  /** sort order */
  sortOrder?: 'ASC' | 'DESC';
  /** sort by source */
  sortField?: string;
  /** search for searching */
  search?: string;
  /** send ui status */
  status?:
    | 'new'
    | 'expired'
    | 'submitted'
    | 'approve'
    | 'rejected'
    | 'pending'
    | 'success'
    | 'failed'
    | 'unknown';
};
export type SignupRequestControllerCreateInvitationEntityRequestApiResponse =
  /** status 200  */ CreateInviteEntityRequestResponseDto;
export type SignupRequestControllerCreateInvitationEntityRequestApiArg = {
  inviteEntityRequestRequestDto: InviteEntityRequestRequestDto;
};
export type SignupRequestControllerGetInviteEntityRequestByIdApiResponse =
  /** status 200  */ CheckInviteEntityRequestByIdResponseDto;
export type SignupRequestControllerGetInviteEntityRequestByIdApiArg = {
  invitationId: string;
};
export type SignupRequestControllerCreateSignUpRequestByInvitationApiResponse =
  /** status 200  */ CreateEntityRequestResponseDto;
export type SignupRequestControllerCreateSignUpRequestByInvitationApiArg = {
  invitationId: string;
  createEntityRequestFormRequestDto: CreateEntityRequestFormRequestDto;
};
export type EntityUserControllerPolicyInfoApiResponse =
  /** status 200  */ UserPolicyInfoDto;
export type EntityUserControllerPolicyInfoApiArg = {
  entityId: string;
};
export type EntityUserControllerFindAllApiResponse =
  /** status 200  */ EntityUserListResponseDto;
export type EntityUserControllerFindAllApiArg = {
  entityId: string;
  getEntityUserListDto: GetEntityUserListDto;
};
export type EntityUserControllerGetUserPoliciesApiResponse =
  /** status 200  */ EntityUserPolicyResponseDto;
export type EntityUserControllerGetUserPoliciesApiArg = {
  entityId: string;
  userId: string;
};
export type EntityUserControllerGetUserByPolicyCodeApiResponse =
  /** status 200  */ GetEntityUserByPolicyResponseDto;
export type EntityUserControllerGetUserByPolicyCodeApiArg = {
  entityId: string;
  policyCode: string;
  /** current page */
  curPage?: number;
  /** page size */
  pageSize?: number;
  /** sort order */
  sortOrder?: 'ASC' | 'DESC';
  /** email for searching */
  account?: string;
  /** if action is include, get user list with specific policy code, if action is exclude, get user list without specific policy code. */
  action?: 'include' | 'exclude';
};
export type SyncJobQueryControllerListSyncJobsApiResponse =
  /** status 200  */ SyncJobListResponseDto;
export type SyncJobQueryControllerListSyncJobsApiArg = {
  entityId: string;
  curPage: string;
  pageSize: string;
};
export type SyncJobQueryControllerGetSyncJobApiResponse =
  /** status 200  */ SyncJobResponseDto;
export type SyncJobQueryControllerGetSyncJobApiArg = {
  entityId: string;
  jobId: string;
};
export type UserSyncControllerGetEntitySyncListApiResponse =
  /** status 200  */ EntitySyncTypeResponseDto[];
export type UserSyncControllerGetEntitySyncListApiArg = {
  entityId: string;
  returnUri: string;
};
export type UserSyncControllerGetSyncHistoryApiResponse =
  /** status 200  */ EntitySyncHistoryResponseDto[];
export type UserSyncControllerGetSyncHistoryApiArg = {
  entityId: string;
  state: 'new' | 'processing' | 'complete' | 'canceled' | 'error';
};
export type UserSyncCommandControllerCreateSyncHistoryApiResponse = unknown;
export type UserSyncCommandControllerCreateSyncHistoryApiArg = {
  entityId: string;
  createSyncHistoryRequestDto: CreateSyncHistoryRequestDto;
};
export type CsvControllerCsvCheckerApiResponse = unknown;
export type CsvControllerCsvCheckerApiArg = {
  /** Entity ID */
  entityId: string;
  body: EntitySyncUserCsvRequestDto[];
};
export type AzureControllerGetTenantListApiResponse =
  /** status 200  */ AzureTenantResponseDto[];
export type AzureControllerGetTenantListApiArg = void;
export type AzureControllerGetTenantGroupsApiResponse =
  /** status 200  */ AzureCursor;
export type AzureControllerGetTenantGroupsApiArg = {
  tenantId: string;
  /** The next page token */
  pageToken?: string;
  /** The next page size */
  pageSize?: number;
  /** Search group displayname */
  search?: string;
};
export type AzureControllerGetTenantSubGroupsApiResponse =
  /** status 200  */ AzureCursor;
export type AzureControllerGetTenantSubGroupsApiArg = {
  tenantId: string;
  groupId: string;
  /** The next page token */
  pageToken?: string;
  /** The next page size */
  pageSize?: number;
  /** Search group displayname */
  search?: string;
};
export type GSuiteControllerGetEntityListApiResponse =
  /** status 200  */ GsuiteDomainResponseDto[];
export type GSuiteControllerGetEntityListApiArg = void;
export type GSuiteControllerGetDomainGroupsApiResponse =
  /** status 200  */ GsuiteCursor;
export type GSuiteControllerGetDomainGroupsApiArg = {
  domainName: string;
  /** The next page token */
  pageToken?: string;
  /** The next page size */
  pageSize?: number;
  /** Search displayname */
  search?: string;
};
export type GSuiteControllerGetDomainSubGroupsApiResponse =
  /** status 200  */ GsuiteCursor;
export type GSuiteControllerGetDomainSubGroupsApiArg = {
  domainName: string;
  groupId: string;
  /** The next page token */
  pageToken?: string;
  /** The next page size */
  pageSize?: number;
};
export type GSuiteControllerGetDomainUnitsApiResponse =
  /** status 200  */ GsuiteUnitResponseDto[];
export type GSuiteControllerGetDomainUnitsApiArg = {
  /** The unit sub path */
  unitPath?: string;
};
export type ClassLinkControllerGetTenantListApiResponse =
  /** status 200  */ ClassLinkTenantResponseDto[];
export type ClassLinkControllerGetTenantListApiArg = void;
export type ClassLinkControllerGetTenantApiResponse =
  /** status 200  */ ClassLinkTenantResponseDto;
export type ClassLinkControllerGetTenantApiArg = {
  tenantId: number;
};
export type ClassLinkControllerGetOrgListApiResponse =
  /** status 200  */ ClassLinkTenantOrgResponseDto[];
export type ClassLinkControllerGetOrgListApiArg = {
  tenantId: number;
  type?: string;
};
export type ClassLinkControllerGetOrgTypeListApiResponse =
  /** status 200  */ ClassLinkTenantOrgTypeResponseDto[];
export type ClassLinkControllerGetOrgTypeListApiArg = {
  tenantId: number;
};
export type ClassLinkControllerGetRoleListApiResponse =
  /** status 200  */ ClassLinkTenantRoleResponseDto[];
export type ClassLinkControllerGetRoleListApiArg = {
  tenantId: number;
};
export type EntityAutoApproverManagementControllerGetEntityAutoApproverListApiResponse =
  /** status 200  */ GetEntityAutoApproverListResponseDto;
export type EntityAutoApproverManagementControllerGetEntityAutoApproverListApiArg =
  {
    /** current page */
    curPage?: number;
    /** page size */
    pageSize?: number;
    /** sort order */
    sortOrder?: 'ASC' | 'DESC';
    /** search for searching */
    search?: string;
    /** sort by email */
    sortField?: string;
  };
export type AutoApproverManagementControllerAddApproverApiResponse = unknown;
export type AutoApproverManagementControllerAddApproverApiArg = {
  createAutoApproverRequestDto: CreateAutoApproverRequestDto;
};
export type CountryManagerManagementControllerGetCountryManagerListApiResponse =
  /** status 200  */ GetCountryManagerResponseDto;
export type CountryManagerManagementControllerGetCountryManagerListApiArg = {
  /** current page */
  curPage?: number;
  /** page size */
  pageSize?: number;
  /** sort order */
  sortOrder?: 'ASC' | 'DESC';
  /** sort by country */
  sortField?: string;
  /** search for keywords */
  search?: string;
};
export type CountryManagerManagementControllerCreateCountryManagerApiResponse =
  unknown;
export type CountryManagerManagementControllerCreateCountryManagerApiArg = {
  createCountryManagerRequestDto: CreateCountryManagerRequestDto;
};
export type DomainManagementControllerGetDomainApiResponse =
  /** status 200  */ AdminEntityDomainResponseDto[];
export type DomainManagementControllerGetDomainApiArg = {
  entityId: string;
};
export type DomainManagementControllerGetDomainWhitelistApiResponse =
  /** status 200  */ StandardResponseDto;
export type DomainManagementControllerGetDomainWhitelistApiArg = void;
export type EntityManagementControllerGetEntityDetailApiResponse =
  /** status 200  */ AdminGetUserEntityDetailResponseDto;
export type EntityManagementControllerGetEntityDetailApiArg = {
  entityId: string;
};
export type ManagementEntityControllerUpdateEntityApiResponse =
  /** status 200  */ CommonResponseDto;
export type ManagementEntityControllerUpdateEntityApiArg = {
  entityId: string;
  adminUpdateEntityRequestDto: AdminUpdateEntityRequestDto;
};
export type ManagementEntityControllerDeleteEntityApiResponse =
  /** status 200  */ CommonResponseDto;
export type ManagementEntityControllerDeleteEntityApiArg = {
  entityId: string;
};
export type EntityManagementControllerGetEntityListApiResponse =
  /** status 200  */ AdminGetUserEntityListWithPaginationResponseDto;
export type EntityManagementControllerGetEntityListApiArg = {
  /** current page */
  curPage?: number;
  /** page size */
  pageSize?: number;
  /** sort order */
  sortOrder?: 'ASC' | 'DESC';
  /** sort by create time */
  sortField?: string;
  /** entity name or domain for searching */
  search?: string;
};
export type PolicyManagementControllerGetPoliciesApiResponse =
  /** status 200  */ GetPoliciesResponseDto[];
export type PolicyManagementControllerGetPoliciesApiArg = void;
export type PolicyManagementControllerGetPermissionsApiResponse =
  /** status 200  */ GetPermissionsResponseDto[];
export type PolicyManagementControllerGetPermissionsApiArg = void;
export type PolicyManagementControllerGetActionsApiResponse =
  /** status 200  */ GetActionsResponseDto[];
export type PolicyManagementControllerGetActionsApiArg = void;
export type PolicyManagementControllerGetResourcesApiResponse =
  /** status 200  */ GetResourcesResponseDto[];
export type PolicyManagementControllerGetResourcesApiArg = void;
export type ProfileManagementControllerGetEntityDetailApiResponse =
  /** status 200  */ GetEntityProfileDetailResponseDto;
export type ProfileManagementControllerGetEntityDetailApiArg = {
  entityId: string;
};
export type RegionManagerManagementControllerGetRegionManagerListApiResponse =
  /** status 200  */ GetRegionManagerResponseDto;
export type RegionManagerManagementControllerGetRegionManagerListApiArg = {
  /** current page */
  curPage?: number;
  /** page size */
  pageSize?: number;
  /** sort order */
  sortOrder?: 'ASC' | 'DESC';
  /** sort by region */
  sortField?: string;
  /** search for searching */
  search?: string;
};
export type RegionManagerManagementControllerCreateRegionManagerApiResponse =
  unknown;
export type RegionManagerManagementControllerCreateRegionManagerApiArg = {
  createRegionManagerRequestDto: CreateRegionManagerRequestDto;
};
export type SignupManagementControllerGetEntityRequestForAdminApiResponse =
  /** status 200  */ GetEntityRequestForAdminResponseDto;
export type SignupManagementControllerGetEntityRequestForAdminApiArg = {
  id: string;
};
export type SignupManagementControllerUpdateEntityRequestApiResponse = unknown;
export type SignupManagementControllerUpdateEntityRequestApiArg = {
  id: string;
  updateEntityRequestBodyDto: UpdateEntityRequestBodyDto;
};
export type SignupManagementControllerGetInviteEntityRequestForAdminApiResponse =
  /** status 200  */ GetInviteEntityRequestForAdminResponseDto;
export type SignupManagementControllerGetInviteEntityRequestForAdminApiArg = {
  id: string;
};
export type SignupManagementControllerGetEntityRequestListForAdminApiResponse =
  /** status 200  */ GetEntityRequestListForAdminResponseDto;
export type SignupManagementControllerGetEntityRequestListForAdminApiArg = {
  /** current page */
  curPage?: number;
  /** page size */
  pageSize?: number;
  /** sort order */
  sortOrder?: 'ASC' | 'DESC';
  /** sort by name */
  sortField?: string;
  /** search for searching */
  search?: string;
  /** entity request status */
  status?: 'new' | 'approve' | 'reject' | 'pending' | 'success' | 'failed';
  /** internal or external when admin portal */
  kind?: string;
};
export type EntityUserManagementControllerFindAllApiResponse =
  /** status 200  */ EntityUserListResponseDto;
export type EntityUserManagementControllerFindAllApiArg = {
  entityId: string;
  getEntityUserListDto: GetEntityUserListDto;
};
export type UserEntityManagementControllerGetUserEntitiesApiResponse =
  /** status 200  */ GetUserEntityListWithPaginationResponseDto;
export type UserEntityManagementControllerGetUserEntitiesApiArg = {
  userId: string;
  /** current page */
  curPage?: number;
  /** page size */
  pageSize?: number;
};
export type DomainControllerVerifyDomainApiResponse = unknown;
export type DomainControllerVerifyDomainApiArg = {
  entityId: string;
  domainId: string;
  verifyType: string;
};
export type DomainControllerDeleteDomainApiResponse = unknown;
export type DomainControllerDeleteDomainApiArg = {
  entityId: string;
  domainId: string;
};
export type EntityUserControllerCreateApiResponse =
  /** status 200  */ AddEntityUsersResponseDto;
export type EntityUserControllerCreateApiArg = {
  entityId: string;
  addEntityUsersRequestDto: AddEntityUsersRequestDto;
};
export type EntityUserControllerRemoveUserApiResponse =
  /** status 200 users removed */ Blob;
export type EntityUserControllerRemoveUserApiArg = {
  entityId: string;
  deleteMspUsersRequestDto: DeleteMspUsersRequestDto;
};
export type EntityUserControllerSyncUsersApiResponse =
  /** status 200  */ SyncEntityUsersResponseDto;
export type EntityUserControllerSyncUsersApiArg = {
  entityId: string;
  syncEntityUsersRequestDto: SyncEntityUsersRequestDto;
};
export type NfcControllerBindApiResponse =
  /** status 200  */ BindEntityNfcResponseDto;
export type NfcControllerBindApiArg = {
  entityId: string;
  userId: string;
  bindEntityNfcDto: BindEntityNfcDto;
};
export type NfcControllerUnbindApiResponse = unknown;
export type NfcControllerUnbindApiArg = {
  entityId: string;
  userId: string;
};
export type NfcControllerClearApiResponse = unknown;
export type NfcControllerClearApiArg = {
  entityId: string;
  clearEntityNfcDto: ClearEntityNfcDto;
};
export type NfcControllerListApiResponse =
  /** status 200  */ EntityNfcListResponseDto;
export type NfcControllerListApiArg = {
  entityId: string;
  /** Search keyword (matched against user email). */
  q?: string;
  /** Page number (1-based). */
  page?: number;
  /** Page size. */
  pageSize?: number;
  /** Sort column. Only Account is sortable. */
  sort?: 'account';
  /** Sort direction. */
  order?: 'asc' | 'desc';
};
export type NfcControllerListCardsApiResponse =
  /** status 200  */ EntityNfcCardListResponseDto;
export type NfcControllerListCardsApiArg = {
  entityId: string;
  /** Keyword, matched case-insensitively against S/N, UID and the bound account email. */
  q?: string;
  page?: number;
  pageSize?: number;
  /** Sort column. Only S/N is sortable. */
  sort?: 'sn';
  /** Sort direction. Cards with no printed S/N stay last. */
  order?: 'asc' | 'desc';
};
export type NfcControllerExportCardsApiResponse =
  /** status 200  */ EntityNfcCardExportResponseDto;
export type NfcControllerExportCardsApiArg = {
  entityId: string;
  /** Keyword, matched the same way as the S/N view list: case-insensitively against S/N, UID and the bound account email. */
  q?: string;
};
export type NfcControllerListOrderCardsApiResponse =
  /** status 200  */ EntityNfcOrderCardsResponseDto;
export type NfcControllerListOrderCardsApiArg = {
  entityId: string;
  orderNo: string;
};
export type NfcControllerParseCsvApiResponse =
  /** status 200  */ ParseEntityNfcCsvResponseDto;
export type NfcControllerParseCsvApiArg = {
  entityId: string;
  body: {
    /** .csv (UTF-8) with one account column and one NFC S/N column; the portal's sample heads them `Account` and `NFC Serial number`, but the header row is not read. */
    file: Blob;
  };
};
export type NfcControllerBatchBindApiResponse =
  /** status 200  */ ImportEntityNfcCsvResponseDto;
export type NfcControllerBatchBindApiArg = {
  entityId: string;
  importEntityNfcCsvDto: ImportEntityNfcCsvDto;
};
export type EntityControllerAcceptUserApiResponse = unknown;
export type EntityControllerAcceptUserApiArg = {
  /** invite code */
  code: string;
};
export type EntityControllerUpdateEntityOwnerApiResponse =
  /** status 200  */ CommonResponseDto;
export type EntityControllerUpdateEntityOwnerApiArg = {
  entityId: string;
  updateEntityOwnerRequestDto: UpdateEntityOwnerRequestDto;
};
export type EntityControllerSetEntityDefaultApiResponse =
  /** status 200  */ CommonResponseDto;
export type EntityControllerSetEntityDefaultApiArg = {
  setEntityDefaultRequestDto: SetEntityDefaultRequestDto;
};
export type PolicyControllerUpdateUserPolicyApiResponse = unknown;
export type PolicyControllerUpdateUserPolicyApiArg = {
  entityId: string;
  updateUserPolicyRequestDto: UpdateUserPolicyRequestDto;
};
export type SyncJobControllerCreateGSuiteSyncJobApiResponse =
  /** status 201  */ SyncJobResponseDto;
export type SyncJobControllerCreateGSuiteSyncJobApiArg = {
  entityId: string;
  createGSuiteSyncJobDto: CreateGSuiteSyncJobDto;
};
export type SyncJobControllerCreateAzureSyncJobApiResponse =
  /** status 201  */ SyncJobResponseDto;
export type SyncJobControllerCreateAzureSyncJobApiArg = {
  entityId: string;
  createAzureSyncJobDto: CreateAzureSyncJobDto;
};
export type SyncJobControllerCreateClassLinkSyncJobApiResponse =
  /** status 201  */ SyncJobResponseDto;
export type SyncJobControllerCreateClassLinkSyncJobApiArg = {
  entityId: string;
  createClassLinkSyncJobDto: CreateClassLinkSyncJobDto;
};
export type SyncJobControllerCreateCsvSyncJobApiResponse =
  /** status 201  */ SyncJobResponseDto;
export type SyncJobControllerCreateCsvSyncJobApiArg = {
  entityId: string;
  createCsvSyncJobDto: CreateCsvSyncJobDto;
};
export type SyncJobControllerPauseSyncJobApiResponse =
  /** status 200  */ SyncJobResponseDto;
export type SyncJobControllerPauseSyncJobApiArg = {
  entityId: string;
  jobId: string;
};
export type SyncJobControllerResumeSyncJobApiResponse =
  /** status 200  */ SyncJobResponseDto;
export type SyncJobControllerResumeSyncJobApiArg = {
  entityId: string;
  jobId: string;
};
export type SyncJobControllerCancelSyncJobApiResponse =
  /** status 200  */ SyncJobResponseDto;
export type SyncJobControllerCancelSyncJobApiArg = {
  entityId: string;
  jobId: string;
};
export type UserSyncCommandControllerUpdateSyncHistoryApiResponse = unknown;
export type UserSyncCommandControllerUpdateSyncHistoryApiArg = {
  entityId: string;
  historyId: string;
  updateSyncHistoryStateRequestDto: UpdateSyncHistoryStateRequestDto;
};
export type SignupRequestControllerApproveApiResponse = unknown;
export type SignupRequestControllerApproveApiArg = {
  id: string;
};
export type SignupRequestControllerDeleteEntityRequestApiResponse = unknown;
export type SignupRequestControllerDeleteEntityRequestApiArg = {
  id: string;
};
export type ManagementEntityControllerUpdateEntityOwnerApiResponse =
  /** status 200  */ CommonResponseDto;
export type ManagementEntityControllerUpdateEntityOwnerApiArg = {
  entityId: string;
  updateEntityOwnerRequestDto: UpdateEntityOwnerRequestDto;
};
export type ManagementEntityUserControllerAddApiResponse =
  /** status 200  */ ForceAddEntityUserResponseDto[];
export type ManagementEntityUserControllerAddApiArg = {
  entityId: string;
  forceAddEntityUsersRequestDto: ForceAddEntityUsersRequestDto;
};
export type ManagementEntityUserControllerRemoveUserApiResponse =
  /** status 200 users removed */ Blob;
export type ManagementEntityUserControllerRemoveUserApiArg = {
  entityId: string;
  deleteMspUsersRequestDto: DeleteMspUsersRequestDto;
};
export type ManagementEntityUserControllerCreateApiResponse =
  /** status 200  */ AddEntityUsersResponseDto;
export type ManagementEntityUserControllerCreateApiArg = {
  entityId: string;
  addEntityUsersRequestDto: AddEntityUsersRequestDto;
};
export type DomainManagementCommandControllerSetDomainVerifiedApiResponse =
  /** status 200  */ CommonResponseDto;
export type DomainManagementCommandControllerSetDomainVerifiedApiArg = {
  domainId: string;
  /** true or false */
  isVerified: string;
};
export type DomainManagementCommandControllerSetDomainVerifyTypeApiResponse =
  /** status 200  */ CommonResponseDto;
export type DomainManagementCommandControllerSetDomainVerifyTypeApiArg = {
  domainId: string;
  /** mx or txt */
  verifyType: string;
};
export type DomainManagementCommandControllerAddDomainApiResponse =
  /** status 200  */ CommonResponseDto;
export type DomainManagementCommandControllerAddDomainApiArg = {
  entityId: string;
  domainName: string;
  /** mx or txt */
  verifyType: string;
};
export type DomainManagementCommandControllerDeleteDomainApiResponse =
  /** status 200  */ CommonResponseDto;
export type DomainManagementCommandControllerDeleteDomainApiArg = {
  domainId: string;
};
export type SignupManagementControllerResendApiResponse = unknown;
export type SignupManagementControllerResendApiArg = {
  id: string;
};
export type SignupManagementControllerRejectApiResponse = unknown;
export type SignupManagementControllerRejectApiArg = {
  id: string;
  entityRequestReasonBodyDto: EntityRequestReasonBodyDto;
};
export type SignupManagementControllerPendApiResponse = unknown;
export type SignupManagementControllerPendApiArg = {
  id: string;
  entityRequestReasonBodyDto: EntityRequestReasonBodyDto;
};
export type AutoApproverManagementControllerDeleteApproverApiResponse =
  /** status 200  */ CommonResponseDto;
export type AutoApproverManagementControllerDeleteApproverApiArg = {
  userId: string;
};
export type RegionManagerManagementControllerUpdateRegionManagerApiResponse =
  unknown;
export type RegionManagerManagementControllerUpdateRegionManagerApiArg = {
  region: string;
  updateRegionManagerRequestDto: UpdateRegionManagerRequestDto;
};
export type RegionManagerManagementControllerDeleteRegionManagerApiResponse =
  unknown;
export type RegionManagerManagementControllerDeleteRegionManagerApiArg = {
  region: string;
};
export type CountryManagerManagementControllerUpdateCountryManagerApiResponse =
  unknown;
export type CountryManagerManagementControllerUpdateCountryManagerApiArg = {
  country: string;
  updateCountryManagerRequestDto: UpdateCountryManagerRequestDto;
};
export type CountryManagerManagementControllerDeleteCountryManagerApiResponse =
  unknown;
export type CountryManagerManagementControllerDeleteCountryManagerApiArg = {
  country: string;
};
export type ProfileManagementControllerUpdateEntityProfileApiResponse =
  /** status 200  */ CommonResponseDto;
export type ProfileManagementControllerUpdateEntityProfileApiArg = {
  updateEntityProfileRequestDto: UpdateEntityProfileRequestDto;
};
export type EntityDomainDto = {
  id: string;
  entity_id: string;
  domain_name: string;
  verify_type: object;
  verify_info: object;
  is_verified: boolean;
  create_time: string;
  modify_time: string;
};
export type PaginationEntityDomainResponseDto = {
  count: number;
  rows: EntityDomainDto[];
};
export type CreateDomainRequestDto = {
  /** Domain name to add to the entity */
  domain: string;
  /** Domain type code (e.g. individual, shared) */
  domain_type_code?: string;
};
export type DomainUserListWithStatusResponseDto = {
  id: string;
  email: string;
  status: 'active' | 'inactive' | 'locked' | 'suspended' | 'deleted';
};
export type GetEntityProfileDto = {
  contact_email: string;
  contact_phone: string;
  owner_id: string;
  zipcode: string;
  country_code: string;
  country: string;
  region: string;
  city: string;
  address: string;
  create_time: string;
  modify_time: string;
  given_name: string;
  family_name: string;
};
export type GetEntityResponseDto = {
  id: string;
  name: string;
  main_domain: string;
  generics_code: string;
  domain_type_code: string;
  area: string;
  create_time: string;
  modify_time: string;
  auto_sync: boolean;
  profile: GetEntityProfileDto;
};
export type GetEntityErrorResponseDto = {
  statusCode: number;
  message: string;
  error: string;
};
export type CommonResponseDto = {
  statusCode: number;
  message: string;
};
export type UpdateEntityRequestDto = {
  /** whether this individual entity should auto sync accounts whose domain are belong to it's main domain */
  auto_sync: boolean;
};
export type PaginationMetaResponseDto = {
  current_page: number;
  per_page: number;
  total_items: number;
  total_pages: number;
};
export type GetUserEntityListDto = {
  id: string;
  name: string;
  country: string;
  country_code: string;
  owner_email: string;
  is_current: boolean;
  is_owner: boolean;
  is_su: boolean;
  is_msp: boolean;
  policy_codes: any[];
  create_time: string;
  modify_time: string;
};
export type GetUserEntityListWithPaginationResponseDto = {
  meta: PaginationMetaResponseDto;
  data: GetUserEntityListDto[];
};
export type GetEntityListErrorResponseDto = {
  statusCode: number;
  message: string;
  error: string;
};
export type EntityGroupListDetail = {
  /** group_id */
  id: string;
  name: string;
  create_time: string;
  modify_time: string;
};
export type EntityGroupListResponseDto = {
  data: EntityGroupListDetail[];
  meta: PaginationMetaResponseDto;
};
export type EntityGroupUserListDetail = {
  /** user id */
  id: string;
  account: string;
  email: string;
  create_time: string;
  modify_time: string;
};
export type EntityGroupUserListResponseDto = {
  data: EntityGroupUserListDetail[];
  meta: PaginationMetaResponseDto;
};
export type PolicyDetailResponseDto = {
  name: string;
  description: string;
  code: string;
  create_time: string;
  modify_time: string;
};
export type EntityGroupPolicyResponseDto = {
  /** user id */
  id: string;
  name: string;
  policies: PolicyDetailResponseDto[];
  create_time: string;
  modify_time: string;
};
export type GetEntityPolicyResponseDto = {
  name: string;
  description: string;
  permission_code: string[];
  code: string;
  create_time: string;
  modify_time: string;
};
export type GetEntityPolicyWithUserResponseDto = {
  name: string;
  description: string;
  permission_code: string[];
  code: string;
  count: number;
  create_time: string;
  modify_time: string;
};
export type GetAllEntityDomainTypesResponseDto = {
  code: string;
  name: string;
  create_time: string;
  modify_time: string;
};
export type GetAllEntityGenericsResponseDto = {
  code: string;
  name: string;
  create_time: string;
  modify_time: string;
};
export type ProfileClass = {
  contact_phone: string;
  contact_email: string;
  zip_code: string;
  country_code: string;
  country: string;
  region: string;
  city: string;
  address: string;
};
export type OwnerContact = {
  name: string;
  first_name: string;
  last_name: string;
  email: string;
  contact_phone: string;
};
export type EntityClass = {
  name: string;
  generics_code: string;
  domain_type_code: string;
  area: string;
  profile: ProfileClass;
  /** Please use the email of owner or admin(aaa@domain.com, please use domain.com) */
  domain: string;
  owner_contact: OwnerContact;
  admin_contact: OwnerContact[];
};
export type EntityRequestPropertyClass = {
  /** User click the signup url from email. */
  invite_entity_request_id: string;
  /** create or send or public */
  request_from: string;
  /** organic or msp or admin_portal */
  source: string;
  creator: string;
  entity: EntityClass;
};
export type GetEntityRequestResponseDto = {
  id: string;
  name: string;
  domain: string;
  property: EntityRequestPropertyClass;
  domain_type_code: string;
  generics_code: string;
  area: string;
  is_auto_build: boolean;
  creator: string;
  status: string;
  entity_id: string;
  request_form: string;
  source: string;
  create_time: string;
  modify_time: string;
  engage_id: string;
};
export type GetEntityRequestListResponseDto = {
  data: GetEntityRequestResponseDto[];
  meta: PaginationMetaResponseDto;
};
export type CreateEntityRequestResponseDto = {};
export type Profile = {
  contact_phone: string;
  contact_email: string;
  zip_code: string;
  country_code: string;
  country: string;
  region: string;
  city: string;
  address: string;
};
export type EntityRequestEntity = {
  name: string;
  generics_code: string;
  domain_type_code: object;
  area: string;
  profile: Profile;
  /** Please use the email of owner or admin(aaa@domain.com, please use domain.com) */
  domain: string;
  owner_contact: OwnerContact;
  admin_contact: OwnerContact[];
};
export type CreateEntityRequestFormRequestDto = {
  /** User click the signup url from email. */
  invite_entity_request_id: string;
  /** create or send or public */
  request_from: string;
  /** organic or msp or admin_portal */
  source: string;
  creator: string;
  entity: EntityRequestEntity;
};
export type CombineResponseDto = {
  id?: string;
  creator: string;
  user_email: string;
  request_from: string;
  source: string;
  /** Can be empty when send mail to user */
  property?: EntityRequestPropertyClass;
  expire_date?: string;
  entity_request_id?: string;
  create_time?: string;
  modify_time?: string;
  /** the organization of figma */
  entityRequestName?: string;
  /** the status of entity request */
  entityRequestStatus?: string;
  /** the status of figma */
  sendUIStatus?: object;
};
export type GetInviteEntityRequestListResponseDto = {
  data: CombineResponseDto[];
  meta: PaginationMetaResponseDto;
};
export type CreateInviteEntityRequestResponseDto = {
  id: string;
  creator: string;
  user_email: string;
  request_from: string;
  source: string;
  property: EntityRequestPropertyClass;
  status: string;
  expire_date: string;
  entity_request_id: string;
  create_time: string;
  modify_time: string;
};
export type InviteEntityRequestRequestDto = {
  creator: string;
  user_email: string;
  request_from: object;
  source: object;
};
export type CheckInviteEntityRequestByIdResponseDto = {
  id?: string;
  creator: string;
  user_email: string;
  request_from: string;
  source: string;
  /** Can be empty when send mail to user */
  property?: EntityRequestPropertyClass;
  expire_date?: string;
  entity_request_id?: string;
  create_time?: string;
  modify_time?: string;
};
export type UserPolicyInfoDto = {
  is_su: boolean;
  polices: PolicyDetailResponseDto[];
};
export type EntityUserListDetailDto = {
  /** user id */
  id: string;
  account: string;
  email: string;
  display_name: string;
  create_time: string;
  modify_time: string;
  policies: string[];
  is_owner: boolean;
  is_su: boolean;
  is_msp: boolean;
};
export type EntityUserListResponseDto = {
  data: EntityUserListDetailDto[];
  meta: PaginationMetaResponseDto;
};
export type BaseQueryType = {};
export type Pagination = {
  /** current page */
  cur_page?: number;
  /** page size */
  page_size?: number;
};
export type Sort = {
  /** sort order */
  order?: 'ASC' | 'DESC';
  /** sort by create time */
  field?: string;
};
export type GetEntityUserListDto = {
  query?: BaseQueryType;
  pagination: Pagination;
  sort: Sort;
  /** role category filter. If not provided, returns all users (including super admins). If "non_su", excludes super admin users unless they are also owner or msp. If "su", returns only super admin users. */
  roleCategory?: 'su' | 'non_su';
};
export type EntityUserPolicyResponseDto = {
  /** user id */
  id: string;
  given_name: string;
  family_name: string;
  email: string;
  account: string;
  policies: PolicyDetailResponseDto[];
  create_time: string;
  modify_time: string;
};
export type GetEntityUserByPolicyDetailDto = {
  /** user id */
  id: string;
  email: string;
  account: string;
  is_owner: boolean;
  create_time: string;
  modify_time: string;
};
export type GetEntityUserByPolicyResponseDto = {
  data: GetEntityUserByPolicyDetailDto[];
  meta: PaginationMetaResponseDto;
};
export type SyncJobResponseDto = {
  id: string;
  entity_id: string;
  type: 'GSUITE' | 'AZURE' | 'CLASSLINK' | 'CSV';
  status:
    | 'PENDING'
    | 'RUNNING'
    | 'SUCCESS'
    | 'FAILED'
    | 'PAUSED'
    | 'CANCELLED'
    | 'TOKEN_EXPIRED';
  keep_users: boolean;
  current_sync_index: number;
  processed_user_count: number;
  failed_count: number;
  error_messages: string[] | null;
  metadata: object;
  create_time: string;
  modify_time: string;
};
export type SyncJobListResponseDto = {
  data: SyncJobResponseDto[];
  meta: PaginationMetaResponseDto;
};
export type EntitySyncTypeResponseDto = {
  name: string;
  code: string;
  url?: string;
  token?: string;
  create_time: string;
  modify_time: string;
};
export type EntitySyncHistoryInfo = {
  id: string;
  name: string;
  verified_domains: string[];
  batch_count: number;
  total_batch_count: number;
  user_count: number;
  total_user: number;
};
export type EntitySyncHistoryResponseDto = {
  id: string;
  info: EntitySyncHistoryInfo;
  state: string;
  keep_users: boolean;
  create_time: string;
  modify_time: string;
};
export type EntitySyncHistoryInfoDto = {
  id?: string;
  name?: string;
  verified_domains: string[];
  total_batch_count: number;
  total_user: number;
};
export type CreateSyncHistoryRequestDto = {
  sync_type_code: string;
  info: EntitySyncHistoryInfoDto;
  keep_users: boolean;
  /** User IDs to remove before sync (ignored if keep_users=true) */
  remove_users?: string[];
};
export type EntitySyncUserCsvRequestDto = {
  email: string;
  given_name: string;
  family_name: string;
  preferredLanguage: string;
};
export type AzureTenantResponseDto = {
  id: string;
  name: string;
  verified_domains: any[];
};
export type AzureError = {
  statusCode?: number;
  message?: string;
};
export type AzureCursorMeta = {
  prev_cursor: string | number;
  next_cursor: string | number;
  total_items: number;
};
export type AzureCursor = {
  meta: AzureCursorMeta;
  data: object[];
};
export type GsuiteVerifiedDomains = {
  name: string;
  type?: string;
};
export type GsuiteDomainResponseDto = {
  id: string;
  name: string;
  verified_domains: GsuiteVerifiedDomains[];
};
export type GsuiteCursorMeta = {
  prev_cursor: string | number;
  next_cursor: string | number;
  total_items: number;
};
export type GsuiteCursor = {
  meta: GsuiteCursorMeta;
  data: object[];
};
export type GsuiteUnitResponseDto = {
  id: string;
  path: string;
  name: string;
  description: string;
  children: boolean;
};
export type ClassLinkTenantResponseDto = {
  id: string;
  name: string;
  tenant_name: string;
};
export type ClassLinkTenantOrgResponseDto = {
  id: string;
  name: string;
  type: string;
};
export type ClassLinkTenantOrgTypeResponseDto = {
  id: string;
  name: string;
};
export type ClassLinkTenantRoleResponseDto = {
  id: string;
  name: string;
};
export type EntityAutoApproverDto = {
  email: string;
  user_id: string;
  create_time: string;
  modify_time: string;
};
export type GetEntityAutoApproverListResponseDto = {
  data: EntityAutoApproverDto[];
  meta: PaginationMetaResponseDto;
};
export type CreateAutoApproverRequestDto = {
  /** User ID to add as auto-approver */
  user_id: string;
  /** Email of the user to add as auto-approver */
  email: string;
};
export type ManagerUser = {
  user_id: string;
  email: string;
  account: string;
};
export type CountryManagerDto = {
  country: string;
  responsible_person: ManagerUser[];
  ref_responsible_person: ManagerUser[];
  ref_super_admin: ManagerUser[];
  create_time: string;
  modify_time: string;
};
export type GetCountryManagerResponseDto = {
  data: CountryManagerDto[];
  meta: PaginationMetaResponseDto;
};
export type CreateCountryManagerRequestDto = {
  country: string;
  responsible_person: ManagerUser[];
  ref_responsible_person: ManagerUser[];
  ref_super_admin: ManagerUser[];
};
export type DomainVerifyInfo = {
  mx_value: string;
  mx_priority: number;
  txt_value: string;
};
export type EntityDto = {
  id: string;
  main_domain: string;
  create_time: string;
  modify_time: string;
};
export type AdminEntityDomainResponseDto = {
  id: string;
  entity_id: string;
  domain_name: string;
  verify_type: string;
  verify_info: DomainVerifyInfo;
  is_verified: boolean;
  create_time: string;
  modify_time: string;
  isMain: boolean;
  entity: EntityDto;
};
export type StandardResponseDto = {
  statusCode: number;
  message: string;
};
export type ResponseErrorDto = {
  statusCode: number;
  message: string;
  error: string;
};
export type EntityDetailProfileDto = {
  entity_id: string;
  contact_email: string;
  owner_id: string;
};
export type EntityDetailEntityRequestDto = {
  id: string;
  request_from: string;
  create_time: string;
  modify_time: string;
};
export type AdminGetUserEntityDetailResponseDto = {
  id: string;
  name: string;
  main_domain: string;
  generics_code: string;
  domain_type_code: string;
  area: string;
  create_time: string;
  modify_time: string;
  profile: EntityDetailProfileDto;
  entity_request: EntityDetailEntityRequestDto;
  entity_request_id: string;
  owner: string;
  owner_id: string;
};
export type AdminUpdateEntityRequestDto = {
  /** entity name */
  name?: string;
  /** main_domain */
  main_domain?: string;
  /** entity domain type */
  domain_type_code?: object;
  /** entity generics code */
  generics_code?: string;
  /** entity area(region) */
  area?: string;
};
export type AdminGetUserEntityListDto = {
  id: string;
  name: string;
  country: string;
  country_code: string;
  owner_email: string;
  is_current: boolean;
  is_owner: boolean;
  is_su: boolean;
  is_msp: boolean;
  policy_codes: any[];
  create_time: string;
  modify_time: string;
  main_domain: string;
  generics_code: string;
  domain_type_code: string;
  area: string;
};
export type AdminGetUserEntityListWithPaginationResponseDto = {
  meta: PaginationMetaResponseDto;
  data: AdminGetUserEntityListDto[];
};
export type GetPoliciesActionDetail = {
  id: string;
  code: string;
  name: string;
  create_time: string;
  modify_time: string;
};
export type GetPoliciesResourceDetail = {
  id: string;
  code: string;
  description: string;
  create_time: string;
  modify_time: string;
};
export type GetPoliciesDetail = {
  id: string;
  level: string;
  code: string;
  action: GetPoliciesActionDetail;
  resource: GetPoliciesResourceDetail;
  create_time: string;
  modify_time: string;
};
export type GetPoliciesResponseDto = {
  code: string;
  name: string;
  description: string;
  permission: GetPoliciesDetail[];
  create_time: string;
  modify_time: string;
};
export type GetPermissionsResponseDto = {
  id: string;
  level: string;
  code: string;
  action: GetPoliciesActionDetail;
  resource: GetPoliciesResourceDetail;
  create_time: string;
  modify_time: string;
};
export type GetActionsResponseDto = {
  id: string;
  code: string;
  name: string;
  create_time: string;
  modify_time: string;
};
export type GetResourcesResponseDto = {
  id: string;
  code: string;
  description: string;
  create_time: string;
  modify_time: string;
};
export type GetEntityProfileDetailResponseDto = {
  entity_id: string;
  contact_email: string;
  contact_phone: string;
  owner_id: string;
  zipcode: string;
  country_code: string;
  country: string;
  region: string;
  city: string;
  address: string;
  create_time: string;
  modify_time: string;
};
export type RegionManagerDto = {
  region: string;
  responsible_person: ManagerUser[];
  ref_responsible_person: ManagerUser[];
  ref_super_admin: ManagerUser[];
  create_time: string;
  modify_time: string;
};
export type GetRegionManagerResponseDto = {
  data: RegionManagerDto[];
  meta: PaginationMetaResponseDto;
};
export type CreateRegionManagerRequestDto = {
  region: string;
  responsible_person: ManagerUser[];
  ref_responsible_person: ManagerUser[];
  ref_super_admin: ManagerUser[];
};
export type GetEntityRequestForAdminResponseDto = {
  id: string;
  name: string;
  domain: string;
  property: EntityRequestPropertyClass;
  domain_type_code: string;
  generics_code: string;
  area: string;
  is_auto_build: boolean;
  creator: string;
  status: string;
  entity_id: string;
  request_form: string;
  source: string;
  create_time: string;
  modify_time: string;
  engage_id: string;
  creatorEmail: string;
};
export type UpdateProfile = {
  contact_phone?: string;
  contact_email?: string;
  zip_code?: string;
  country_code?: string;
  country?: string;
  region?: string;
  city?: string;
  address?: string;
};
export type UpdateOwnerContact = {
  name?: string;
  first_name?: string;
  last_name?: string;
  email?: string;
  contact_phone?: string;
};
export type UpdateEntityClass = {
  name?: string;
  generics_code?: string;
  domain_type_code?: string;
  area?: string;
  profile?: UpdateProfile;
  domain?: string;
  owner_contact?: UpdateOwnerContact;
  admin_contact?: UpdateOwnerContact[];
};
export type UpdateEntityRequestPropertyDto = {
  invite_entity_request_id?: string;
  request_from?: string;
  source?: string;
  creator?: string;
  entity?: UpdateEntityClass;
};
export type UpdateEntityRequestBodyDto = {
  name?: string;
  domain?: string;
  property?: UpdateEntityRequestPropertyDto;
  domain_type_code?: string;
  generics_code?: string;
  area?: string;
  is_auto_build?: boolean;
};
export type GetInviteEntityRequestForAdminResponseDto = {
  id?: string;
  creator: string;
  user_email: string;
  request_from: string;
  source: string;
  /** Can be empty when send mail to user */
  property?: EntityRequestPropertyClass;
  expire_date?: string;
  entity_request_id?: string;
  create_time?: string;
  modify_time?: string;
  /** the organization of figma */
  entityRequestName?: string;
  /** the status of entity request */
  entityRequestStatus?: string;
  /** the status of figma */
  sendUIStatus?: object;
  creatorEmail: string;
};
export type GetEntityRequestListForAdminResponseDto = {
  data: GetEntityRequestResponseDto[];
  meta: PaginationMetaResponseDto;
};
export type CountDetails = {
  invite: number;
  created: number;
  include: number;
  entity_account: number;
};
export type User = {
  id: string;
  email: string;
  account: string;
  create_time: string;
  modify_time: string;
};
export type AddEntityUsersDetails = {
  invite: boolean;
  count: CountDetails;
  data: User[];
};
export type AddEntityUsersResponseDto = {
  details: AddEntityUsersDetails;
};
export type ImportError = {
  row: number;
  error: string;
};
export type AddUserExceptionResponseDto = {
  code:
    | 'IMPORT_USER_ERROR_ENTITY_NOT_FOUND'
    | 'IMPORT_USER_ERROR_PROFILE_NOT_FOUND'
    | 'IMPORT_USER_ERROR_IMPORT_FAILED'
    | 'IMPORT_USER_ERROR_SOMETHING_WRONG';
  message: ImportError;
};
export type AddEntityUserDto = {
  email: string;
  first_name: string;
  last_name: string;
};
export type AddEntityUsersRequestDto = {
  userData: AddEntityUserDto[];
};
export type DeleteMspUsersRequestDto = {
  /** Delete user from entity. (use user_id, not record id) */
  ids: string[];
  all: boolean;
};
export type SyncEntityUsersInfo = {
  id: string;
  name: string;
  verified_domains: string[];
  total_batch_count: number;
  total_user: number;
  batch_count: number;
  user_count: number;
};
export type SyncEntityUsersResponseDto = {
  id: string;
  sync_type_code: string;
  info: SyncEntityUsersInfo;
  state: string;
  detail: string | null;
  keep_users: boolean;
  create_time: string;
  modify_time: string;
  details: AddEntityUsersDetails;
};
export type Metadata = {
  sync_type_code:
    | 'regular'
    | 'system'
    | 'csv'
    | 'csv_admin'
    | 'gsuite'
    | 'azure'
    | 'azure_scim'
    | 'yaml'
    | 'classlink'
    | 'mvb_migrate'
    | 'external_classlink'
    | 'external_canvas'
    | 'auto_sync';
  history_id: string;
};
export type SsoSyncUser = {
  sso_id: string;
  email: string;
  display_name?: string;
  given_name: string;
  family_name: string;
  preferredLanguage: string;
};
export type SyncEntityUsersRequestDto = {
  metadata: Metadata;
  users: SsoSyncUser[];
};
export type BindEntityNfcResponseDto = {
  /** The account that was bound. */
  account_id: string;
  /** Account name shown on the result page. */
  account: string;
  /** Canonical printed S/N (uppercase, trimmed) — may differ in case from what was sent. Null for a tapped card that ViewSonic did not issue. */
  sn: string | null;
  /** Normalized UID (lowercase, hyphens removed). */
  nfc_num: string;
  /** Card-type fingerprint, null unless the reader supplied nfc_atr / nfc_sak / nfc_atqa. Not shown in the UI. */
  hash: string | null;
};
export type NfcCardAlreadyBoundConflict = {
  account: string;
};
export type NfcCardAlreadyBoundMessage = {
  reason: string;
  conflict?: NfcCardAlreadyBoundConflict;
};
export type NfcExceptionResponseDto = {
  request_id: string;
  code:
    | 'NFC_SN_UNKNOWN'
    | 'NFC_CARD_IDENTIFIER_INVALID'
    | 'NFC_CSV_FILE_REQUIRED'
    | 'NFC_CSV_INVALID_COLUMNS'
    | 'NFC_CSV_OVER_ROW_LIMIT'
    | 'NFC_EXPORT_TOO_LARGE'
    | 'NFC_USER_NOT_IN_ENTITY'
    | 'NFC_ORDER_NOT_FOUND'
    | 'NFC_ACCOUNT_ALREADY_BOUND'
    | 'NFC_CARD_ALREADY_BOUND';
  status_code: number;
  service: string;
  message: string | NfcCardAlreadyBoundMessage;
  path: string;
  timestamp: string;
};
export type BindEntityNfcDto = {
  /** Printed card S/N. Case and surrounding whitespace are normalized server-side, so the raw user input can be sent as-is. */
  sn?: string;
  /** UID as read by the reader. Mutually exclusive with sn. Case and hyphens are normalized server-side; any other separator is rejected, because vs-account2 stores it verbatim and the card would bind twice. */
  nfc_num?: string;
  /** ISO14443-A ATS. Optional, and only meaningful with nfc_num; it feeds the card-type hash, not card identity. Omit unless the reader emits the same format as the firmware. */
  nfc_atr?: string;
  /** ISO14443-A SAK. See nfc_atr. */
  nfc_sak?: string;
  /** ISO14443-A ATQA. See nfc_atr. */
  nfc_atqa?: string;
};
export type ClearEntityNfcDto = {
  /** List of account ids (vs-account account_id) to clear NFC bindings for. Ignored when clear_all is true. Max 1000. */
  account_id?: string[];
  /** If true, clear NFC bindings for all users in the entity. */
  clear_all?: boolean;
};
export type EntityNfcListItemDto = {
  /** vs-account account_id */
  account_id: string;
  /** Account username as stored on entity_users.account. */
  account: string;
  email: string;
  /** Bound NFC number, or null when the user has no NFC binding. */
  nfc_num: string | null;
  /** Printed S/N of the bound card. Null both when nothing is bound and when the bound card was enrolled by tapping (not ViewSonic-issued) — read it together with nfc_num. */
  sn: string | null;
};
export type EntityNfcListResponseDto = {
  data: EntityNfcListItemDto[];
  meta: PaginationMetaResponseDto;
};
export type EntityNfcCardListItemDto = {
  /** null 代表非 ViewSonic 發行的卡（只能感應綁定）。 */
  sn: string | null;
  /** UID。 */
  nfc_num: string;
  /** UNBOUND：卡在這個 entity 底下，但還沒綁定任何帳號。 */
  bind_status: 'BOUND' | 'UNBOUND';
  /** 未綁定時為 null。 */
  account_id: string | null;
  account: string | null;
  email: string | null;
};
export type EntityNfcCardListResponseDto = {
  data: EntityNfcCardListItemDto[];
  meta: PaginationMetaResponseDto;
};
export type EntityNfcCardExportItemDto = {
  sn: string | null;
  nfc_num: string;
  bind_status: 'BOUND' | 'UNBOUND';
  account: string | null;
  /** ISO 8601 UTC. Null for a card nobody holds. The display format is the frontend's call. */
  bound_at: string | null;
};
export type EntityNfcCardExportResponseDto = {
  total: number;
  data: EntityNfcCardExportItemDto[];
};
export type EntityNfcOrderCardItemDto = {
  sn: string;
};
export type EntityNfcOrderCardsResponseDto = {
  order_no: string;
  /** Card count for this order. Not a fixed box size -- the vendor sample includes an order holding a single card, so do not derive page sizes from it. */
  total: number;
  data: EntityNfcOrderCardItemDto[];
};
export type EntityNfcCsvReadyItemDto = {
  /** Account (username) as read from the CSV row. */
  account: string;
  /** Printed S/N as read from the CSV row (uppercased, trimmed). */
  sn: string;
};
export type EntityNfcCsvBlockedItemDto = {
  /** Account (username) as read from the CSV row. */
  account: string;
  /** Printed S/N as read from the CSV row. */
  sn: string;
  reason:
    | 'ACCOUNT_ALREADY_BOUND'
    | 'NFC_ALREADY_BOUND'
    | 'NOT_IN_ENTITY'
    | 'UNKNOWN_SN'
    | 'MISSING_EMAIL';
};
export type ParseEntityNfcCsvResponseDto = {
  ready: EntityNfcCsvReadyItemDto[];
  blocked: EntityNfcCsvBlockedItemDto[];
};
export type EntityNfcCsvFailedItemDto = {
  /** Account echoed from the import request. */
  account: string;
  /** Printed S/N echoed from the import request. */
  sn: string;
  reason:
    | 'NOT_IN_ENTITY'
    | 'ACCOUNT_NOT_FOUND'
    | 'ACCOUNT_ALREADY_BOUND'
    | 'NFC_ALREADY_BOUND'
    | 'UNKNOWN';
};
export type ImportEntityNfcCsvResponseDto = {
  /** Number of rows vs-account2 reported as bound. The downstream broadcast is not part of this count -- a broadcast that fails is logged and leaves the row counted as a success. */
  success_count: number;
  /** Rows that were not written, each with the reason it was rejected (PRD AC11). Rows carrying UNKNOWN are the ones with no specific cause -- surface those as "System error, please retry". */
  failed: EntityNfcCsvFailedItemDto[];
};
export type ImportEntityNfcCsvItemDto = {
  /** Account (username) to bind. Re-resolved server-side against entity_users at write time, so a stale account_id from the parse step (renamed/removed users, membership changes) cannot leak into the bind. Rows whose account no longer resolves to an entity member are moved to `failed`. */
  account: string;
  /** Printed S/N to bind. Normalized here (trimmed, uppercased) rather than trusted from the client, then resolved to a UID server-side. */
  sn: string;
};
export type ImportEntityNfcCsvDto = {
  /** Rows to bind, each `{ account, sn }`. An empty list is accepted and answers with an empty result. */
  items: ImportEntityNfcCsvItemDto[];
};
export type UpdateEntityOwnerRequestDto = {
  /** target user account id */
  user_id: string;
  /** target owner account */
  account: string;
};
export type SetEntityDefaultRequestDto = {
  /** entity id to set as default */
  entity_id: string;
};
export type UpdateUserPolicyRequestDto = {
  /** User IDs to update policy for. */
  ids: string[];
  action: 'add' | 'remove';
  /** Policy code to assign or revoke. */
  policy_code: string;
};
export type GSuiteUserSetEntryDto = {
  /** Type of user set to sync */
  type: 'all' | 'group' | 'orgunit';
  /** Group email or OrgUnit path — required when type is "group" or "orgunit" */
  id?: string;
};
export type CreateGSuiteSyncJobDto = {
  domain: string;
  /** Keep existing entity users (true) or replace all with this userset (false) */
  keep_users: boolean;
  usersets: GSuiteUserSetEntryDto[];
};
export type AzureUserSetEntryDto = {
  /** Type of user set to sync */
  type: 'all' | 'group';
  /** Group ID — required when type is "group" */
  id?: string;
};
export type CreateAzureSyncJobDto = {
  tenantId: string;
  /** Keep existing entity users (true) or replace all with this userset (false) */
  keep_users: boolean;
  usersets: AzureUserSetEntryDto[];
};
export type ClassLinkUserSetEntryDto = {
  /** "org" resolves org -> classes -> users by role; "admin" syncs tenant administrators */
  type: 'org' | 'admin';
  /** Org (school) ID — required when type is "org" */
  orgId?: string;
  /** Roles to sync — required when type is "org" */
  roles?: string[];
};
export type CreateClassLinkSyncJobDto = {
  tenantId: number;
  /** Keep existing entity users (true) or replace all with this userset (false) */
  keep_users: boolean;
  /** User sets to sync. Use type "org" with orgId for school users (by class/role), type "admin" for tenant administrators. */
  usersets: ClassLinkUserSetEntryDto[];
};
export type CsvUserDto = {
  email: string;
  first_name: string;
  last_name: string;
};
export type CsvUserSetEntryDto = {
  users: CsvUserDto[];
};
export type CreateCsvSyncJobDto = {
  /** Keep existing entity users (true) or replace all with this userset (false) */
  keep_users: boolean;
  usersets: CsvUserSetEntryDto[];
};
export type UpdateSyncHistoryStateRequestDto = {
  state: 'new' | 'processing' | 'complete' | 'canceled' | 'error';
  detail?: string;
};
export type ForceAddEntityUserResponseDto = {
  entity_id: string;
  /** Account id */
  user_id: string;
  account: string;
  sync_time: string;
  /** Synchronization code */
  sync_code:
    | 'regular'
    | 'system'
    | 'csv'
    | 'csv_admin'
    | 'gsuite'
    | 'azure'
    | 'azure_scim'
    | 'yaml'
    | 'classlink'
    | 'mvb_migrate'
    | 'external_classlink'
    | 'external_canvas'
    | 'auto_sync';
  client_id: string;
};
export type BasicUser = {
  id: string;
  account: string;
};
export type ForceAddEntityUsersRequestDto = {
  data: BasicUser[];
};
export type EntityRequestReasonBodyDto = {
  /** fill reason when reject or pend entity request */
  reason?: string;
};
export type UpdateRegionManagerRequestDto = {
  responsible_person: ManagerUser[];
  ref_responsible_person: ManagerUser[];
  ref_super_admin: ManagerUser[];
};
export type UpdateCountryManagerRequestDto = {
  responsible_person: ManagerUser[];
  ref_responsible_person: ManagerUser[];
  ref_super_admin: ManagerUser[];
};
export type UpdateEntityProfileRequestDto = {
  entity_id: string;
  contact_email?: string;
  contact_phone?: string;
  owner_id?: string;
  zipcode?: string;
  country_code?: string;
  country?: string;
  region?: string;
  city?: string;
  address?: string;
};
export const {
  useDomainControllerFindAllDomainQuery,
  useDomainControllerCreateDomainMutation,
  useDomainControllerGetDomainUserListQuery,
  useEntityControllerGetEntityQuery,
  useEntityControllerUpdateEntityMutation,
  useEntityControllerGetUserEntityListQuery,
  useEntityGroupControllerFindAllGroupsQuery,
  useEntityGroupControllerFindUserByGroupQuery,
  useEntityGroupControllerGetGroupPoliciesQuery,
  usePolicyControllerFindAllQuery,
  usePolicyControllerFindAllWithUserQuery,
  useSignupRequestControllerGetAllEntityDomainTypesQuery,
  useSignupRequestControllerGetAllEntityGenericsQuery,
  useSignupRequestControllerGetEntityRequestListQuery,
  useSignupRequestControllerCreateSignUpRequestMutation,
  useSignupRequestControllerGetEntityRequestQuery,
  useSignupRequestControllerGetInviteEntityRequestListQuery,
  useSignupRequestControllerCreateInvitationEntityRequestMutation,
  useSignupRequestControllerGetInviteEntityRequestByIdQuery,
  useSignupRequestControllerCreateSignUpRequestByInvitationMutation,
  useEntityUserControllerPolicyInfoQuery,
  useEntityUserControllerFindAllMutation,
  useEntityUserControllerGetUserPoliciesQuery,
  useEntityUserControllerGetUserByPolicyCodeQuery,
  useSyncJobQueryControllerListSyncJobsQuery,
  useSyncJobQueryControllerGetSyncJobQuery,
  useUserSyncControllerGetEntitySyncListQuery,
  useUserSyncControllerGetSyncHistoryQuery,
  useUserSyncCommandControllerCreateSyncHistoryMutation,
  useCsvControllerCsvCheckerMutation,
  useAzureControllerGetTenantListQuery,
  useAzureControllerGetTenantGroupsQuery,
  useAzureControllerGetTenantSubGroupsQuery,
  useGSuiteControllerGetEntityListQuery,
  useGSuiteControllerGetDomainGroupsQuery,
  useGSuiteControllerGetDomainSubGroupsQuery,
  useGSuiteControllerGetDomainUnitsQuery,
  useClassLinkControllerGetTenantListQuery,
  useClassLinkControllerGetTenantQuery,
  useClassLinkControllerGetOrgListQuery,
  useClassLinkControllerGetOrgTypeListQuery,
  useClassLinkControllerGetRoleListQuery,
  useEntityAutoApproverManagementControllerGetEntityAutoApproverListQuery,
  useAutoApproverManagementControllerAddApproverMutation,
  useCountryManagerManagementControllerGetCountryManagerListQuery,
  useCountryManagerManagementControllerCreateCountryManagerMutation,
  useDomainManagementControllerGetDomainQuery,
  useDomainManagementControllerGetDomainWhitelistQuery,
  useEntityManagementControllerGetEntityDetailQuery,
  useManagementEntityControllerUpdateEntityMutation,
  useManagementEntityControllerDeleteEntityMutation,
  useEntityManagementControllerGetEntityListQuery,
  usePolicyManagementControllerGetPoliciesQuery,
  usePolicyManagementControllerGetPermissionsQuery,
  usePolicyManagementControllerGetActionsQuery,
  usePolicyManagementControllerGetResourcesQuery,
  useProfileManagementControllerGetEntityDetailQuery,
  useRegionManagerManagementControllerGetRegionManagerListQuery,
  useRegionManagerManagementControllerCreateRegionManagerMutation,
  useSignupManagementControllerGetEntityRequestForAdminQuery,
  useSignupManagementControllerUpdateEntityRequestMutation,
  useSignupManagementControllerGetInviteEntityRequestForAdminQuery,
  useSignupManagementControllerGetEntityRequestListForAdminQuery,
  useEntityUserManagementControllerFindAllMutation,
  useUserEntityManagementControllerGetUserEntitiesQuery,
  useDomainControllerVerifyDomainMutation,
  useDomainControllerDeleteDomainMutation,
  useEntityUserControllerCreateMutation,
  useEntityUserControllerRemoveUserMutation,
  useEntityUserControllerSyncUsersMutation,
  useNfcControllerBindMutation,
  useNfcControllerUnbindMutation,
  useNfcControllerClearMutation,
  useNfcControllerListQuery,
  useNfcControllerListCardsQuery,
  useNfcControllerExportCardsQuery,
  useNfcControllerListOrderCardsQuery,
  useNfcControllerParseCsvMutation,
  useNfcControllerBatchBindMutation,
  useEntityControllerAcceptUserQuery,
  useEntityControllerUpdateEntityOwnerMutation,
  useEntityControllerSetEntityDefaultMutation,
  usePolicyControllerUpdateUserPolicyMutation,
  useSyncJobControllerCreateGSuiteSyncJobMutation,
  useSyncJobControllerCreateAzureSyncJobMutation,
  useSyncJobControllerCreateClassLinkSyncJobMutation,
  useSyncJobControllerCreateCsvSyncJobMutation,
  useSyncJobControllerPauseSyncJobMutation,
  useSyncJobControllerResumeSyncJobMutation,
  useSyncJobControllerCancelSyncJobMutation,
  useUserSyncCommandControllerUpdateSyncHistoryMutation,
  useSignupRequestControllerApproveMutation,
  useSignupRequestControllerDeleteEntityRequestMutation,
  useManagementEntityControllerUpdateEntityOwnerMutation,
  useManagementEntityUserControllerAddMutation,
  useManagementEntityUserControllerRemoveUserMutation,
  useManagementEntityUserControllerCreateMutation,
  useDomainManagementCommandControllerSetDomainVerifiedMutation,
  useDomainManagementCommandControllerSetDomainVerifyTypeMutation,
  useDomainManagementCommandControllerAddDomainMutation,
  useDomainManagementCommandControllerDeleteDomainMutation,
  useSignupManagementControllerResendMutation,
  useSignupManagementControllerRejectMutation,
  useSignupManagementControllerPendMutation,
  useAutoApproverManagementControllerDeleteApproverMutation,
  useRegionManagerManagementControllerUpdateRegionManagerMutation,
  useRegionManagerManagementControllerDeleteRegionManagerMutation,
  useCountryManagerManagementControllerUpdateCountryManagerMutation,
  useCountryManagerManagementControllerDeleteCountryManagerMutation,
  useProfileManagementControllerUpdateEntityProfileMutation,
} = injectedRtkApi;
